/** Einstieg für /tools/map-viewer/baseforge-viewer.js – stellt window.BfViewer3D bereit. */
import { create, renderImage, supported, thumbnail } from './viewer';

declare global {
  interface Window { BfViewer3D?: { create: typeof create; thumbnail: typeof thumbnail; supported: typeof supported; renderImage: typeof renderImage } }
}

window.BfViewer3D = { create, thumbnail, supported, renderImage };
window.dispatchEvent(new Event('bfviewer3d:ready'));
